import { SettingsType } from '@Components/Settings/SettingsType';

export interface ISettingsState {
    isOpen: boolean;
    settingsType: SettingsType;
}

export const initialSettingsState: ISettingsState = {
    isOpen: false,
    settingsType: null,
};
